import legalEntities from 'modules/core/store/collections/legalEntities'

import { ALLOWED_COUNTRIES, Country } from 'modules/payroll_bundle/store/models/PayrollBundle'

/*
 * Why these methods?
 *
 * 'payroll_bundle' app installation lives under the condition of having installed
 * a country default bundle. This country default bundle goes 1-1 with legal entities
 * and each of them have a country associated.
 * Furthermore, the 'payroll_bundle' addon installation lives behind the country default
 * installation, this means that we need to make sure we install the same country for, first,
 * the legal entity and, then, payroll.
 *
 * In terms of logic we need to:
 * Prevent users to install an addon from a country that they do not have a legal entity
 *     (somebody with a LE from Spain to install the 'payroll_bundle' addon from France)
 */
export const filterCountries = (): Country[] => {
  const legalEntitiesCountries = legalEntities.map((legalEntity) => legalEntity.country)

  const availableCountries = legalEntitiesCountries.map((country) => {
    const key = Object.keys(ALLOWED_COUNTRIES).find(
      (countryKey) => ALLOWED_COUNTRIES[countryKey] === country
    )
    return key || 'other'
  })

  return [...new Set(availableCountries)]
}
